import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import moment from 'moment';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import {useTranslation} from 'react-i18next';

import {Flex} from '../../styles';

import Classification from '../Classification';

const Cartoonito = ({item}) => {
    const {t} = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const [showDetails, setShowDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    item.rate = (item.rate || 'livre')
        .toString()
        .toLowerCase()
        .replace(' anos', '');

    useEffect(() => {
        if (showDetails === null && expanded) {
            handleLoadShowDetails();
        }
        // eslint-disable-next-line
    }, [expanded]);

    const handleLoadShowDetails = async () => {
        setLoading(true);

        let response = await axios.get(
            // eslint-disable-next-line
            `https://schedule.dmti.cloud/show-detail?id=${item?.id}&feed=CNLA_BR&mapped=true&output=json`,
        );

        if (
            response.status === 200 &&
            response.data['com.turner.dmtla.schedule.dto.ShowDetailDTO']
        ) {
            setShowDetails(
                response.data['com.turner.dmtla.schedule.dto.ShowDetailDTO'],
            );
        } else {
            setShowDetails({});
        }

        setLoading(false);
    };

    if ((item?.serie || '').trim().length === 0) {
        return null;
    }

    return (
        <Container onClick={() => setExpanded(!expanded)}>
            <Flex
                justifyContent="flex-start"
                direction="row"
                width="100%"
                height="47px"
                boxSizing="border-box"
            >
                <Time>{moment(item.airDateTime).format('HH:mm')}</Time>
                <Title>{item.serie.toLowerCase()}</Title>
            </Flex>
            <ExpandContainer expanded={expanded}>
                <Flex flex="1" alignItems="flex-start" direction="column">
                    <AboutTitle>{item.title.toLowerCase()}</AboutTitle>
                    <AboutText>{item.storyline}</AboutText>

                    <Flex margin="8px 0 0 0" direction="row">
                        <AboutTitle>
                            {t('cartoonito.programming.yearOfProduction')}:{' '}
                        </AboutTitle>
                        <AboutText>
                            {loading || !showDetails ? (
                                <Skeleton width="138px" />
                            ) : (
                                showDetails?.releaseYear
                            )}
                        </AboutText>
                    </Flex>
                    <Flex direction="row">
                        <AboutTitle>
                            {t('cartoonito.programming.genres')}:{' '}
                        </AboutTitle>
                        <AboutText>
                            {item.genreList?.replace(/,/g, ', ')}
                        </AboutText>
                    </Flex>
                    <Flex
                        justifyContent="flex-start"
                        width="100%"
                        direction="row"
                    >
                        <AboutTitle>
                            {t('cartoonito.programming.director')}:{' '}
                        </AboutTitle>
                        <AboutText>
                            {loading || !showDetails ? (
                                <Skeleton width="210px" />
                            ) : (
                                showDetails?.directorList?.replace(/,/g, ', ')
                            )}
                        </AboutText>
                    </Flex>
                    <Flex margin="0 0 8px 0" direction="row">
                        <AboutTitle>
                            {t('cartoonito.programming.cast')}:{' '}
                        </AboutTitle>
                        <AboutText>
                            {loading || !showDetails ? (
                                <Skeleton width="236px" />
                            ) : (
                                showDetails?.actorList?.replace(/,/g, ', ')
                            )}
                        </AboutText>
                    </Flex>
                    <Classification
                        size={32}
                        color={rateLevel[item.rate || 'livre']?.color}
                        value={rateLevel[item.rate || 'livre']?.value}
                    />
                </Flex>
            </ExpandContainer>
        </Container>
    );
};

const rateLevel = {
    livre: {
        label: 'LIVRE',
        value: 'L',
        color: '#00a651',
    },
    10: {
        label: '10 ANOS',
        value: '10',
        color: '#0095DA',
    },
    12: {
        label: '12 ANOS',
        value: '12',
        color: '#FBC115',
    },
    14: {
        label: '14 ANOS',
        value: '14',
        color: '#F58220',
    },
    16: {
        label: '16 ANOS',
        value: '16',
        color: '#EC1D25',
    },
    18: {
        label: '18 ANOS',
        value: '18',
        color: '#000',
    },
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: auto;
    padding: 8px 0px;
    box-sizing: border-box;
    cursor: pointer;

    :not(:last-child) {
        border-bottom: 1px solid #d0c8d0;
    }
`;

const Time = styled.span`
    color: rgb(76, 76, 76);
    font-size: 18px;
    font-family: 'AvenirNextRoundedStd';
    font-weight: bold;
    line-height: 18px;
    margin: 0;
    margin-right: 32px;
`;

const Title = styled.p`
    color: rgb(0, 0, 0);
    font-size: 18px;
    font-family: 'AvenirNextRoundedStd';
    font-weight: bold;
    line-height: 31px;
    text-transform: capitalize;
    margin: 0;
`;

const ExpandContainer = styled(Flex)`
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    max-height: 0;
    overflow: hidden;
    transition: 0.3s all ease-in-out;

    ${({expanded}) =>
        expanded &&
        `
        max-height: 600px;
    `}
`;

const AboutTitle = styled.p`
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-family: 'AvenirNextRoundedStd';
    font-weight: bold;
    line-height: 18px;
    margin: 0;
    margin-right: 6px;
    text-transform: capitalize;
`;

const AboutText = styled.p`
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-family: 'AvenirNextRoundedStd';
    font-weight: initial;
    line-height: 18px;
    margin: 0;
`;

export default Cartoonito;
